import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReminderBell = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Artboard" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "bell",
				transform: "translate(1.000000, 0.000000)",
				fill: "currentColor",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M19,10 L19,8 C19,3.581722 15.418278,2.705415e-16 11,0 C6.581722,-2.705415e-16 3,3.581722 3,8 L3,10 C2.95035707,11.2330421 2.38989647,12.3898299 1.453,13.193 C0.62019621,13.9026289 0.0985838647,14.9103136 0,16 C0,18.5 4.112,20 11,20 C17.888,20 22,18.5 22,16 C21.9014161,14.9103136 21.3798038,13.9026289 20.547,13.193 C19.6101035,12.3898299 19.0496429,11.2330421 19,10 Z",
					id: "Path"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M8.145,21.9 C8.53616569,23.1477858 9.69233797,23.9969922 11,23.9969922 C12.307662,23.9969922 13.4638343,23.1477858 13.855,21.9 C12.961,21.966 12.011,22 11,22 C9.989,22 9.039,21.968 8.145,21.9 Z",
					id: "Path"
				})]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgReminderBell);
export default ForwardRef;
